function getLastNCharacters(str, n) {
    return str.substr(Math.max(str.length - n, 0))
}

function getTimeRemaining(milliseconds) {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const days = Math.floor(totalSeconds / (24 * 60 * 60));
    const hours = Math.floor((totalSeconds % (24 * 60 * 60)) / (60 * 60));
    const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
    const seconds = totalSeconds % 60;

    return {
        days,
        hours,
        minutes,
        seconds
    };
}

function updateCountdown(holder, nextDeliveryDate) {
    const now = new Date().getTime()
    const end = new Date(nextDeliveryDate.cutoff).getTime()
    const timeStamp = end - now

    if (timeStamp < 0) {
        //Here, we simply don't update the timer..
        //Future: We could move to the next date in the list and count from there..
        //but as we're not as SPA, it's not super important
        return
    }

    const timeRemaining = getTimeRemaining(timeStamp)

    const loader = holder.getElementsByClassName(
        "countdown-timer-loader"
    )[0]
    const message = holder.getElementsByClassName("countdown-timer-msg")[0]

    message.innerHTML = `<i class="far fa-clock me-1"></i> 
        Order within <div class="timer-grid">
        <span>${timeRemaining.days}<span>Days</span></span>
        <span>${timeRemaining.hours}<span>Hours</span></span>
        <span>${timeRemaining.minutes}<span>Minutes</span></span>
        <span>${timeRemaining.seconds}<span>Seconds</span></span>
    </div> for ${nextDeliveryDate.day_name} delivery`

    if (!holder.dataset.hasLoaded) {
        holder.dataset.hasLoaded = true
        loader.style.display = "none"
        message.style.opacity = 1


        //Remove fixed height, and resize it
        // holder.style.height = "auto"
        // const newHeight = holder.scrollHeight + "px"
        // holder.style.height = newHeight

        // //CLeanup
        // holder.addEventListener("transitioned", () => {
        //     holder.style.height = "auto"
        // }, {
        //     once: true
        // })
    }

}

$(function () {
    const holders = document.querySelectorAll(".countdown-timer")

    holders.forEach((holder) => {
        if (holder) {

            //Freez the current height
            //holder.style.height = `${holder.offsetHeight}px`


            //First, grab details of upcoming deliveries
            $.get("/ajax/getShippingCountdownDetails", (data) => {
                //DATA will be array of: id, day_name, delivery_date, cutoff

                //Get current datetime
                const dt = new Date()

                //Find first date in shipping dates that hasn't passed the current date
                const nextDeliveryDate = data.find((el) => {
                    return dt < new Date(el.cutoff)
                })

                if (nextDeliveryDate) {
                    updateCountdown(holder, nextDeliveryDate)
                    setInterval(() => updateCountdown(holder, nextDeliveryDate), 1000)
                }
            })
        }
    })
})
